import React  from "react";

import PropTypes from "prop-types";

import BasePadding from "@cayuse/shared-react.components.base-padding";
import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";

import { ResearchTeamList } from "components/BudgetBuilder/ResearchTeam";
import { useEditingContext } from "components/BudgetBuilder/shared/EditingContext";
import PeriodDropdown from "components/BudgetBuilder/shared/PeriodDropdown";

import LineItemsList from "../LineItemsList";
import SummaryList from "../Summary";
import styles from "./styles.css";


const SponsorCostsMainView = () => {
	const { researchTeam, sponsorCosts } = useEditingContext();

	return (
		<div className={styles.budgetSettings}>
			<BasePadding>
				<VerticalSpacing>
					<PeriodDropdown disabled={researchTeam[0] || sponsorCosts[0]} />
				</VerticalSpacing>
				<VerticalSpacing>
					<ResearchTeamList isCostShare={false} />
				</VerticalSpacing>
				<VerticalSpacing>
					<LineItemsList />
				</VerticalSpacing>
				<VerticalSpacing>
					<SummaryList />
				</VerticalSpacing>
			</BasePadding>
		</div>
	);
};

SponsorCostsMainView.propTypes = {
	handleFormLoaded: PropTypes.func,
	setFormVariables: PropTypes.func,
	formVariables: PropTypes.object,
};
export default SponsorCostsMainView;
